"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const reader_1 = require("./reader");
const index_1 = require("../botones/index");
/**Modal para leer QR */
class ModalQR extends React.PureComponent {
    render() {
        const style = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 10000,
            position: "fixed",
            background: "black",
            display: "flex",
            flexDirection: "column"
        };
        return (React.createElement("div", { style: style },
            React.createElement("div", { style: { flex: "0 1 0", color: "white", background: "#07154A" } },
                React.createElement("div", { style: { display: "flex", alignItems: "center", flexWrap: "wrap" } },
                    React.createElement("div", { style: { flex: "1 0 0" } }),
                    React.createElement("span", { style: { flex: "0 1 auto" } },
                        React.createElement("i", { className: "fa fa-qrcode fa-fw" }),
                        React.createElement("label", { style: { color: "white" } }, "Leer QR")),
                    React.createElement("div", { style: { flex: "1 0 0" } }),
                    React.createElement("div", { style: { flex: "0 1 auto" } },
                        React.createElement(index_1.Button, { style: "danger", iconClass: "fa fa-times", onClick: () => this.props.onClose(undefined) }, "Cancelar")))),
            React.createElement(reader_1.QRReader, { onChange: x => this.props.onClose(x), style: {
                    flex: "1 0 0"
                } }))
        // <Modal title={this.props.params.titulo} onClose={() => this.props.onClose(undefined)}>
        // </Modal>
        );
    }
}
exports.ModalQR = ModalQR;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/qr/modal.js
// module id = 2249
// module chunks = 0